import {
  getMarks,
  removeCommentPopup,
  removeMark,
} from '../../../../../../../../../utility/commentExtension';
import keyCodes from '../../../../../../editJournal/constants/keyCodes';
import getCursorPosInBlock from './getCursorPosInBlock';

export default ({ editor, props, eventCode }) => {
  /**
   * To ensure next block(expanded) is executed for the resusability of code
   */
  const {
    value: { selection },
  } = editor;
  const { isCollapsed } = selection;
  const { isFocusAtBeginning, isInBetween, isFocusAtEnd } = getCursorPosInBlock(
    { editor },
  );
  if ((isInBetween || isFocusAtEnd) && isCollapsed) {
    if (eventCode === keyCodes.BACKSPACE) editor.moveAnchorBackward(1);
    else if (eventCode === keyCodes.DELETE) editor.moveFocusForward(1);
  }

  if (isFocusAtBeginning && isCollapsed) {
    if (eventCode === keyCodes.BACKSPACE) editor.select(selection);
    else if (eventCode === keyCodes.DELETE) editor.moveFocusForward(1);
  }

  if (editor.value.selection.isExpanded) {
    const activeMarks = getMarks(editor);
    removeMark(activeMarks, editor);
    editor.delete();

    /**
     * close pop-up if there are not comments in active marks
     */
    if (!editor.value.activeMarks.size) {
      const { updatePopUpKeys, showCommentCard, showContextCard } = props;
      setTimeout(() => {
        removeCommentPopup({
          editor,
          updatePopUpKeys,
          showCommentCard,
          showContextCard,
        });
      }, 0);
    }

    return true;
  }
  if (isCollapsed) {
    editor.select(selection);
    if (eventCode === keyCodes.DELETE) return true;
  }

  return false;
};
